/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

const initialState = {
  accountTypeSelected: '',
  accountEmail: '',
  buildingType: null,
  repeatAccountEmail: '',
  verificationCode: '',
  firstName: '',
  lastName: '',
  roleName: '',
  mobileNumber: '',
  telephoneNumber: '',
  passwordValue: '',
  repeatPasswordValue: '',
  landLordType: null,
  accessCodeMobile: '',
  isLinkedEnterprise: '',
  companyRegistrationNumber: '',
  linkedEnterpriseNumber: '',
  companyData: null,
  businessVatRegistration: '',
  businessVatData: null,
  propertyTypesSelected: [],
  emailCodeResent: false,
  answers: '',
  organisationName: '',
  registrationNumber: '',
  buildingAndStreet: '',
  buildingAndStreet2: '',
  townOrCity: '',
  county: '',
  postCode: '',
  landlordChallenges: [],
  landlordChallengeDescription: '',
};

export const registrationJourneySlice = createSlice({
  name: 'registrationJourney',
  initialState,
  reducers: {
    resetRegistrationJourney: () => initialState,
    setPropertyTypesSelected: (state, action) => {
      // If the user has selected the Residential checkbox (position 0 in the array), the data is checked,
      // then that as the value. Otherwise, set the value to nothing/not checked (null).
      const data = action.payload;
      if (data.value === 'Residential') {
        state.propertyTypesSelected[0] = data.checked ? data.value : null;
      } else if (data.value === 'Commercial') {
        state.propertyTypesSelected[1] = data.checked ? data.value : null;
      }
    },
    setAccountTypeSelected: (state, action) => {
      state.accountTypeSelected = action.payload;
    },

    setAccountEmail: (state, action) => {
      state.accountEmail = action.payload;
    },
    setRepeatAccountEmail: (state, action) => {
      state.repeatAccountEmail = action.payload;
    },
    setVerificationCode: (state, action) => {
      state.verificationCode = action.payload;
    },
    setAccountFirstName: (state, action) => {
      state.firstName = action.payload;
    },
    setAccountLastName: (state, action) => {
      state.lastName = action.payload;
    },
    setAccountRoleName: (state, action) => {
      state.roleName = action.payload;
    },
    setAccountMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    setAccountTelephoneNumber: (state, action) => {
      state.telephoneNumber = action.payload;
    },
    setAccountPassword: (state, action) => {
      state.passwordValue = action.payload;
    },
    setAccountRepeatedPassword: (state, action) => {
      state.repeatPasswordValue = action.payload;
    },
    setAccountLandLordType: (state, action) => {
      state.landLordType = action.payload;
    },
    setAccessCodeMobile: (state, action) => {
      state.accessCodeMobile = action.payload;
    },
    setIsLinkedEnterprise: (state, action) => {
      state.isLinkedEnterprise = action.payload;
    },
    setCompanyRegistrationNumber: (state, action) => {
      state.companyRegistrationNumber = action.payload;
    },
    setLinkedEnterpriseNumber: (state, action) => {
      state.linkedEnterpriseNumber = action.payload;
    },
    setCompanyData: (state, action) => {
      state.businessVatData = null;
      state.companyData = action.payload;
    },
    setBusinessVatRegistration: (state, action) => {
      state.businessVatRegistration = action.payload;
    },
    setBusinessVatData: (state, action) => {
      state.companyData = null;
      state.businessVatData = action.payload;
    },
    setEmailCodeResent: (state, action) => {
      state.emailCodeResent = action.payload;
    },
    setAnswers: (state, action) => {
      state.answers = action.payload;
    },
    setAccountOrganisationName: (state, action) => {
      state.organisationName = action.payload;
    },
    setAccountRegistrationNumber: (state, action) => {
      state.registrationNumber = action.payload;
    },
    setAccountBuildingAndStreet: (state, action) => {
      state.buildingAndStreet = action.payload;
    },
    setAccountBuildingAndStreet2: (state, action) => {
      state.buildingAndStreet2 = action.payload;
    },
    setAccountTownOrCity: (state, action) => {
      state.townOrCity = action.payload;
    },
    setAccountCounty: (state, action) => {
      state.county = action.payload;
    },
    setAccountPostCode: (state, action) => {
      state.postCode = action.payload;
    },
    setLandlordChallenges: (state, action) => {
      const data = action.payload;
      const current = state.landlordChallenges;
      if (data.value && !data.checked)
        state.landlordChallenges = _.without(current, data.value);
      else state.landlordChallenges = _.concat(current, data.value);
    },
    setLandlordChallengeDescription: (state, action) => {
      state.landlordChallengeDescription = action.payload;
    },
  },
});

export const {
  setPropertyTypesSelected,
  setAccountTypeSelected,
  setAccountEmail,
  setRepeatAccountEmail,
  setVerificationCode,
  setAccountFirstName,
  setAccountLastName,
  setAccountRoleName,
  setAccountMobileNumber,
  setAccountTelephoneNumber,
  setAccountLandLordType,
  setAccessCodeMobile,
  setAccountPassword,
  setAccountRepeatedPassword,
  setAccountContactDetails,
  setIsLinkedEnterprise,
  setCompanyRegistrationNumber,
  setLinkedEnterpriseNumber,
  setCompanyData,
  setBusinessVatRegistration,
  setBusinessVatData,
  setEmailCodeResent,
  setAnswers,
  setAccountOrganisationName,
  setAccountRegistrationNumber,
  setAccountBuildingAndStreet,
  setAccountBuildingAndStreet2,
  setAccountTownOrCity,
  setAccountCounty,
  setAccountPostCode,
  setLandlordChallenges,
  setLandlordChallengeDescription,
  resetRegistrationJourney,
} = registrationJourneySlice.actions;

export const getPropertyTypesSelected = (state) =>
  state.registrationJourney.propertyTypesSelected;

export const getAccountTypeSelected = (state) =>
  state.registrationJourney.accountTypeSelected;

export const getAccountEmail = (state) =>
  state.registrationJourney.accountEmail;

export const getRepeatAccountEmail = (state) =>
  state.registrationJourney.repeatAccountEmail;

export const getVerificationCode = (state) =>
  state.registrationJourney.verificationCode;

export const getAccountFirstName = (state) =>
  state.registrationJourney.firstName;

export const getAccountLastName = (state) => state.registrationJourney.lastName;

export const getAccountRoleName = (state) => state.registrationJourney.roleName;

export const getAccountMobileNumber = (state) =>
  state.registrationJourney.mobileNumber;

export const getAccountTelephoneNumber = (state) =>
  state.registrationJourney.telephoneNumber;

export const getAccountPasswordValue = (state) =>
  state.registrationJourney.passwordValue;

export const getAccountRepeatPasswordValue = (state) =>
  state.registrationJourney.repeatPasswordValue;

export const getAccountLandLordType = (state) =>
  state.registrationJourney.landLordType;

export const getAccessCodeMobile = (state) =>
  state.registrationJourney.accessCodeMobile;

export const getIsLinkedEnterprise = (state) =>
  state.registrationJourney.isLinkedEnterprise;

export const getCompanyRegistrationNumber = (state) =>
  state.registrationJourney.companyRegistrationNumber;

export const getLinkedEnterpriseNumber = (state) =>
  state.registrationJourney.linkedEnterpriseNumber;

export const getCompanyData = (state) => state.registrationJourney.companyData;

export const getBusinessVatRegistration = (state) =>
  state.registrationJourney.businessVatRegistration;

export const getBusinessVatData = (state) =>
  state.registrationJourney.businessVatData;

export const getEmailCodeResent = (state) =>
  state.registrationJourney.emailCodeResent;

export const getAnswers = (state) => state.registrationJourney.answers;

export const getAccountOrganisationName = (state) =>
  state.registrationJourney.organisationName;

export const getAccountRegistrationNumber = (state) =>
  state.registrationJourney.registrationNumber;

export const getAccountBuildingAndStreet = (state) =>
  state.registrationJourney.buildingAndStreet;

export const getAccountBuildingAndStreet2 = (state) =>
  state.registrationJourney.buildingAndStreet2;

export const getAccountTownOrCity = (state) =>
  state.registrationJourney.townOrCity;

export const getAccountCounty = (state) => state.registrationJourney.county;

export const getAccountPostCode = (state) => state.registrationJourney.postCode;

export const getLandlordChallenges = (state) =>
  state.registrationJourney.landlordChallenges;

export const getLandlordChallengeDescription = (state) =>
  state.registrationJourney.landlordChallengeDescription;

export default registrationJourneySlice.reducer;
